export default __webpack_public_path__ + "static/tile_tablet@2x-6d7e4fa23b4136bb497cc1762b35496d.png";